import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import EarningGraph from "../../features/dashboard/earningGraph";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import usePermission from "../../hooks/usePermission";
import { useEffect, useState } from "react";
import { GRAPH_TYPE, GRAPH_TYPE_DAILY } from "../../utils/enums";
import {
  useLazyChangeGraphStatusQuery,
  useLazyGetDashboardQuery,
  useLazyAnalyticsExportQuery,
 
} from "../../services/dashboard";

const ManageAnalytics = () => {
  const navigate = useNavigate();

  const [dashboardDataMethod] = useLazyGetDashboardQuery();
  const [changeStatus] = useLazyChangeGraphStatusQuery();

  const [totalEarningGraph, setTotalEarningGraph] = useState();
  const [dashboardData, setDashboardData] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [triggerExport] = useLazyAnalyticsExportQuery();
  
  const [graphFor, setGraphFor] = useState<number | null | undefined>(
    GRAPH_TYPE.EARNING_GRAPH
  );


  const getExportCsv = async () => {
    setIsLoading(true);
    try {
      const response = await triggerExport().unwrap();
      if (response?.statusCode === 200) {
        window.open(response?.data || "");
      }
    } catch (error) {
      // no-op
    } finally {
      setIsLoading(false);
    }
  };


  const [earningType, setEarninType] = useState<string>(
    GRAPH_TYPE_DAILY.WEEKLY
  );
  usePermission({ label: "Manage Analytics", page_permission: "isView" });

  const handleChangeStatus = async (graphFor: number, type: string) => {
    setIsLoading(true);
    try {
      const response = await changeStatus({
        graphFor,
        type,
      }).unwrap();
      if (response?.statusCode === 200) {
        setTotalEarningGraph(response?.data);
      }
    } catch (error: any) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getDashboardData = async () => {
    setIsLoading(true);
    try {
      const response = await dashboardDataMethod().unwrap();
      if (response?.statusCode === 200) {
        setDashboardData(response?.data);
      }
    } catch (error: any) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);
  useEffect(() => {
    if (graphFor) {
      handleChangeStatus(graphFor, earningType);
    }
  }, [earningType, graphFor]);
  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Manage Analytics</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Manage Analytics
          </p>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary"  onClick={getExportCsv}>
            <DownloadIcon /> Export
          </Button>
        </div>
      </div>
      <div className="stats_boxes gap_m">
        <div className="cards">
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>AED {dashboardData?.totalEarning || "0"}</h2>
          <p>Total Earning</p>
        </div>
      </div>
      <div className="grid_sc gap_m">
        <EarningGraph
          data={totalEarningGraph}
          setIssueType={setEarninType}
          issueType={earningType}
          setGraphFor={setGraphFor}
        />
      </div>
    </MainContainer>
  );
};

export default ManageAnalytics;
